module.exports = __webpack_public_path__ + "static/media/eila-on-the-couch2.0a00894c.jpg";